/*
Used for unit conversion in Design tools. Implemented first, may be prudent to switch all unit conversion systems to one method.
 */
export const INCHES_TO_CM = 2.54;
export const CM_TO_INCHES = 1 / INCHES_TO_CM;

export const PSI_TO_MPA = 1 / 145.038;
export const MPA_TO_PSI = 1 / PSI_TO_MPA;

export const MPH_TO_KPH = 1.60934;
export const KPH_TO_MPH = 1 / MPH_TO_KPH;

export const PSIPERIN_TO_MPAPERCM = 0.00271447;
export const MPAPERCM_TO_PSIPERIN = 1 / PSIPERIN_TO_MPAPERCM;

export const LB_TO_KG = 1 / 2.20462;
export const KG_TO_LB = 1 / LB_TO_KG;

export const LBFT3_TO_KGM3 = 16.0185;
export const KGM3_TO_LBFT3 = 1 / LBFT3_TO_KGM3;

export const YD2IN_TO_M2CM = 2.12376349;
export const M2CM_to_YD2IN = 1 / YD2IN_TO_M2CM;

export const DEGF_TO_DEGC = function (degF: number) {
  return (degF - 32) * (5 / 9);
};

export const DEGC_TO_DEGF = function (degC: number) {
  return degC * (9 / 5) + 32;
};

export const roundAfterUnitConversion = function (v: number, numSigFigs: number = 4, fixed: boolean = false): number {
  // const sigFigs = 4;
  if (fixed) {
    return Number(v.toFixed(numSigFigs));
  }
  return Number(v.toPrecision(numSigFigs));
};

/*
Setup to allow for dynamic unit conversion in Agency Cost tool, since user can set arbitrary units.

Also used for LCCA unit conversions
 */

export enum ImperialUnits {
  MASS_LB = 'lb',
  MASS_SHTN = 't',
  LENGTH_IN = 'in',
  LENGTH_FT = 'ft',
  LENGTH_MI = 'mi',
  VOLUME_GAL = 'gal',
  VOLUME_FT3 = 'ft3',
  VOLUME_YD3 = 'yd3',
  AREA_YD2 = 'yd2',
  VOLUME_YD2IN = 'yd2*in',
  DENSITY_LBFT3 = 'lb/ft3',
  TEMP_F = 'F',
  SPEED_MPH = 'm/h',
  PRESSURE_PSI = 'psi',
  HOURS = 'h',
  DAYS = 'd',
  PERSON_HOURS = 'h',
  UNITS = 'units',
  // OTHER = 'other'
}

export enum MetricUnits {
  MASS_KG = 'kg',
  MASS_MTON = 'mt',
  LENGTH_CM = 'cm',
  LENGTH_M = 'm',
  LENGTH_KM = 'km',
  VOLUME_CM3 = 'cm3',
  VOLUME_L = 'l',
  VOLUME_M3 = 'm3',
  VOLUME_M2CM = 'm2*cm',
  DENSITY_KGM3 = 'kg/m3',
  AREA_M2 = 'm2',
  TEMP_C = 'C',
  SPEED_KPH = 'km/h',
  PRESSURE_MPA = 'MPa',
  HOURS = 'h',
  DAYS = 'd',
  PERSON_HOURS = 'h',
  UNITS = 'units',
  // OTHER = 'other'
}

export const UnitMapImperialToMetric = {
  [ImperialUnits.MASS_LB]: MetricUnits.MASS_KG,
  [ImperialUnits.MASS_SHTN]: MetricUnits.MASS_MTON,
  [ImperialUnits.LENGTH_IN]: MetricUnits.LENGTH_CM,
  [ImperialUnits.LENGTH_FT]: MetricUnits.LENGTH_M,
  [ImperialUnits.LENGTH_MI]: MetricUnits.LENGTH_KM,
  [ImperialUnits.VOLUME_GAL]: MetricUnits.VOLUME_L,
  [ImperialUnits.VOLUME_FT3]: MetricUnits.VOLUME_CM3,
  [ImperialUnits.VOLUME_YD3]: MetricUnits.VOLUME_M3,
  [ImperialUnits.VOLUME_YD2IN]: MetricUnits.VOLUME_M2CM,
  [ImperialUnits.DENSITY_LBFT3]: MetricUnits.DENSITY_KGM3,
  [ImperialUnits.AREA_YD2]: MetricUnits.AREA_M2,
  [ImperialUnits.TEMP_F]: MetricUnits.TEMP_C,
  [ImperialUnits.SPEED_MPH]: MetricUnits.SPEED_KPH,
  [ImperialUnits.PRESSURE_PSI]: MetricUnits.PRESSURE_MPA,
  [ImperialUnits.HOURS]: MetricUnits.HOURS,
  [ImperialUnits.DAYS]: MetricUnits.DAYS,
  [ImperialUnits.PERSON_HOURS]: MetricUnits.PERSON_HOURS,
  [ImperialUnits.UNITS]: MetricUnits.UNITS,
  // [ImperialUnits.OTHER]: MetricUnits.OTHER,
};

export const UnitMapMetricToImperial = (function () {
  const ret: { [index: string]: ImperialUnits } = {};
  // @ts-ignore
  Object.entries(UnitMapImperialToMetric).forEach((I) => { ret[I[1]] = I[0]; });
  return ret;
}());
